// extracted by mini-css-extract-plugin
export var animationContainer = "_og-0";
export var footer = "_og-1";
export var gray = "_og-2";
export var lineItem = "_og-3";
export var lineItemImage = "_og-4";
export var lineItemInfo = "_og-5";
export var lineItemText = "_og-6";
export var lineItems = "_og-7";
export var modalContent = "_og-8";
export var options = "_og-9";
export var orderName = "_og-a";
export var refundAmount = "_og-b";